<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="title">Leave a review</div>
  <span class="description">We’d love to hear from you. Scan the<br>qr code to leave a google review!</span>
  <app-qrcode content="https://oon.gl/vFStZT" [size]="370"/>
</div>
